import React from 'react';
import './Contact.css';

const Contact = ({ language }) => {
  const translations = {
    en: {
      title: 'READY TO SHIP WITH CONFIDENCE?',
      contactPerson: 'Contact: Mr. Walid Farag',
      email: 'Email: Walid.farag@movexa.com',
      sendMessage: 'SEND MESSAGE',
    },
    ar: {
      title: 'هل أنت مستعد للشحن بثقة؟',
      contactPerson: 'جهة الاتصال: السيد وليد فراج',
      email: 'البريد الإلكتروني: Walid.farag@movexa.com',
      sendMessage: 'إرسال رسالة',
    },
  };

  const t = translations[language];

  const handleSendMessage = () => {
    window.location.href = 'mailto:Walid.farag@movexa.com?subject=Movexa Inquiry&body=Hello, I would like to discuss our shipping needs with Movexa.';
  };

  return (
    <section className="contact" id="contact">
      <div className="contact-container">
        <h2>{t.title}</h2>
        <div className="contact-info">
          <p className="contact-person">{t.contactPerson}</p>
          <p className="contact-email">{t.email}</p>
        </div>
        <button className="send-message-btn" onClick={handleSendMessage}>
          {t.sendMessage}
        </button>
      </div>
    </section>
  );
};

export default Contact;
